import React from 'react';
import Rodal from 'rodal';
import { useImmer } from 'use-immer';
import Select from 'react-select';

import Button from 'components/common/Button';
import LanguageIcon from 'assets/language_grey.svg';
import DeleteIcon from 'assets/delete.svg';
import HelpIcon from 'assets/help_grey.svg';

const Card = (props) => {
  return (
    <div className="flex flex-wrap w-full items-center text-lg rounded-md border border-gray-300 px-4 py-4 my-8">
      <div className="w-9/12 text-left">{`${props.name}`}</div>
      <div className="w-1/12">
        <div class="relative inline-block w-10 ml-4 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            //   checked={true}
            class="focus:outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label
            for="toggle"
            class="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer"
          ></label>
        </div>
      </div>
      <div className="w-1/12">
        <Button
          intent="success"
          // showSpinner={true}
          type="button"
          extendClass="text-md"
          // onClick={() => {
          //   setState((draft) => {
          //     draft.toggleAddCredential = true;
          //   });
          // }}
          // loading={sendUserInviteTeamState.loading ? true : false}
          //   disable={userLoginState.loading ? false : isSubmitting}
        >
          Verify
        </Button>
      </div>
      <div className="w-1/12">
        <div
          title="Delete"
          className="bg-red-500 px-2 py-2 w-10 h-10 rounded-md cursor-pointer  "
        >
          <img className="w-full h-full" src={DeleteIcon} />
        </div>
      </div>
    </div>
  );
};

const NewCredentialModalContent = (props) => {
  return (
    <div className="mt-4">
      <div className="text-gray-800 text-2xl font-bold mb-2 ml-2 flex items-center">
        <span>New Credential</span>{' '}
        <div className="ml-6 relative new-seed-tooltip-parent">
          <img src={HelpIcon} width="30" height="30" />
          <span className="w-64 font-medium bg-secondary-active text-white absolute new-seed-tooltip-child text-sm border border-gray-300 px-2 py-2 rounded-sm">
            Info for new credential
          </span>
        </div>
      </div>
      <div className="text-md">
        <div className="flex  flex-wrap w-full mt-8">
          <div className="w-3/12">Type</div>
          <div className="pl-3 w-9/12">
            <Select
              // inputValue={defaultValue}
              styles={customStyles}
              options={credTypeOptions}
              value={props.addCredentialType}
              isSearchable={false}
              name="addCredentialType"
              onChange={props.onChangeSelect}
              placeholder="Select Credential Type"
              // defaultValue={defaultValue}
              // defaultInputValue={defaultValue}
            />
          </div>
        </div>

        <div className="mt-20 text-right">
          <div className="flex items-center justify-between">
            <div className="text-right w-full">
              <Button
                intent="primary"
                // showSpinner={true}
                type="button"
                extendClass="text-md"
                // onClick={() => {
                //   setState((draft) => {
                //     draft.toggleAddCredential = true;
                //   });
                // }}
                // loading={sendUserInviteTeamState.loading ? true : false}
                //   disable={userLoginState.loading ? false : isSubmitting}
              >
                Cancel
              </Button>
              <Button
                intent="primary"
                // showSpinner={true}
                type="button"
                extendClass="ml-2 text-md"
                // onClick={() => {
                //   setState((draft) => {
                //     draft.toggleAddCredential = true;
                //   });
                // }}
                // loading={sendUserInviteTeamState.loading ? true : false}
                //   disable={userLoginState.loading ? false : isSubmitting}
              >
                Authenticate
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const credTypeOptions = [
  { label: 'Other', value: 'other' },
  { label: 'Amazon Web Services', value: 'AWS' },
];

const customStyles = {
  menu: (provided, state) => ({ ...provided, marginTop: '1px' }),
};

const SettingsCredentialPage = (props) => {
  const [state, setState] = useImmer({
    toggleAddCredential: false,
    addCredentialType: '',
  });

  const onChangeSelect = (value, target) => {
    console.log('on change select', target.name, target);
    setState((draft) => {
      draft[target.name] = value;
    });
  };

  return (
    <div id="collection-settings-credentials" className="">
      <div className="text-right">
        <Button
          intent="primary"
          // showSpinner={true}
          type="button"
          extendClass="text-lg"
          onClick={() => {
            setState((draft) => {
              draft.toggleAddCredential = true;
            });
          }}
          // loading={sendUserInviteTeamState.loading ? true : false}
          //   disable={userLoginState.loading ? false : isSubmitting}
        >
          New Credential
        </Button>
      </div>
      <div className="mt-10">
        <Card name="AWS Credential #1" />
        <Card name="AWS Credential #2" />
        <Card name="GCP Credential #1" />
      </div>

      <Rodal
        className="rodal-collections-settings-credentials"
        visible={state.toggleAddCredential}
        onClose={() => {
          setState((draft) => {
            draft.toggleAddCredential = false;
          });
        }}
        customStyles={{
          width: '40%',
          height: '350px',
        }}
        closeMaskOnClick={true}
        closeOnEsc={true}
        animationType="enter"
        showCloseButton={false}
      >
        <NewCredentialModalContent
          addCredentialType={state.addCredentialType}
          onChangeSelect={onChangeSelect}
        />
      </Rodal>
    </div>
  );
};

export default SettingsCredentialPage;
